import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, EMAIL, BLOG_URL, INSTAGRAM_URL } from "../../data/content";
import { useLang } from "../../i18n/LangContext";
import { PRIVACY } from "../../i18n/privacy";

export const Footer = () => {
  const { t, lang } = useLang();
  return (
  <footer data-testid="site-footer" className="bg-[#1C1917] text-stone-300">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#E9B79F]">{t.footer.write}</p>
      <a
        href={`mailto:${EMAIL}`}
        data-testid="footer-email-link"
        className="group mt-6 inline-flex flex-wrap items-center gap-4 font-serif text-3xl text-[#FBF9F5] sm:text-5xl lg:text-7xl"
      >
        <span className="break-all bg-[linear-gradient(#C85A32,#C85A32)] bg-[length:0%_2px] bg-left-bottom bg-no-repeat pb-1 transition-[background-size] duration-700 group-hover:bg-[length:100%_2px]">
          {EMAIL}
        </span>
        <ArrowUpRight className="h-8 w-8 text-[#C85A32] transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 sm:h-12 sm:w-12" />
      </a>
      <div className="mt-20 grid gap-12 border-t border-stone-700 pt-12 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-stone-400">
            {t.footer.desc}
          </p>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-[#E9B79F]">{t.runts}</p>
        </div>
        <ul className="grid grid-cols-2 gap-3 text-sm">
          {NAV.map((to) => (
            <li key={to}>
              <Link to={to} data-testid={`footer-nav-${to.slice(1) || "home"}`} className="transition-colors hover:text-[#FBF9F5]">
                {t.nav[to]}
              </Link>
            </li>
          ))}
        </ul>
        <div className="text-sm md:text-right">
          <a href={BLOG_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-blog-link" className="inline-flex items-center gap-2 transition-colors hover:text-[#FBF9F5]">
            {t.footer.blog} <ArrowUpRight size={14} />
          </a>
          <br />
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="mt-3 inline-flex items-center gap-2 transition-colors hover:text-[#FBF9F5]">
            <Instagram size={14} /> @lunghefrequenze
          </a>
          <p className="mt-6 text-stone-400">© {new Date().getFullYear()} Lunghe Frequenze APS</p>
          <Link to="/privacy" data-testid="footer-privacy-link" className="mt-2 inline-block text-stone-400 underline-offset-4 transition-colors hover:text-[#FBF9F5] hover:underline">
            {PRIVACY[lang].footerLink}
          </Link>
        </div>
      </div>
    </div>
  </footer>
  );
};
